import React, { useContext } from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../../../Icons/CloseIcon';
import { ModalContext } from '../../ModalContext';

interface ImgPreviewerModalContainerProps {
  imgUrl: string;
}
const ImgPreviewerModalContainer: React.FC<ImgPreviewerModalContainerProps> = ({
  imgUrl,
}) => {
  const modalContext = useContext(ModalContext);
  const onClickCancel = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    modalContext?.setShowModal(false);
  };

  return (
    <Container
      // className='no-click-record'
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <IconContainer
        onClick={
          // onClickCancel
          (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.stopPropagation();
            onClickCancel(e);
          }
        }
      >
        <CloseIconStyle>
          <CloseIcon />
        </CloseIconStyle>
      </IconContainer>

      <ImageArea>
        <Img src={imgUrl} alt='preview image' />
      </ImageArea>
    </Container>
  );
};

export default ImgPreviewerModalContainer;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  flex-direction: column;
  width: 620px;
  gap: 20px;

  @media (max-width: 884px) {
    width: 100%;
    max-width: 620px;
    margin-top: 20px;
    padding: 0 12px;
    box-sizing: border-box;
  }
`;

const IconContainer = styled.div`
  cursor: pointer;
  align-self: flex-end;

  transform: scale(100%);
  transition: transform 0.3s ease-out;

  &:hover {
    transform: scale(110%);
  }
`;

const ImageArea = styled.div`
  display: grid;
  width: 620px;
  height: 620px;
  cursor: crosshair;

  @media (max-width: 884px) {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
`;

const Img = styled.img`
  display: flex;
  width: 620px;
  height: 620px;
  object-fit: contain;
  object-position: center;

  @media (max-width: 884px) {
    width: 100%;
    height: 100%;
  }
`;

const CloseIconStyle = styled.div`
  background-color: white;
  border-radius: 50%;
  padding: 6px;
`;
